<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Session"
      />
      <h1>
        Session
      </h1>
      <div v-if="sessionRoles">
        <h2>
          Roles
        </h2>
        <ul>
          <li
            v-for="role in sessionRoles"
            :key="role"
          >
            {{ role }}
          </li>
        </ul>
        <Button
          title="Stop Session"
          @click="stopSession()"
        />
      </div>
      <div
        v-else
        @keyup.enter="startSession()"
      >
        <TextInput
          v-model:value="loginID"
          title="Login ID"
        />
        <SecretInput
          v-model:value="loginSecret"
          title="Login Secret"
        />
        <CheckboxButton
          v-model:value="saveSession"
          title="Save Session"
        />
        <Button
          title="Start Session"
          @click="startSession()"
        />
      </div>
    </VerticalNavigator>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import ErrorModal from "@/components/modals/error.vue"
  import {Session as SessionClient} from "@/endpoints/rutsolve/gql/resolvers/session"
  import CheckboxButton from "@/components/checkbox_button.vue"
  import Button from "@/components/button.vue"
  import SecretInput from "@/components/inputs/secret.vue"
  import TextInput from "@/components/inputs/text.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import {RutsolveToken} from "@/storage/rutsolve_token"
  import router from "@/router"
  import Breadcrumb from "@/components/breadcrumb.vue"

  const error = ref<Error>(null)
  const sessionClient = new SessionClient()
  const loginID = ref<string>(null)
  const loginSecret = ref<string>(null)
  const saveSession = ref<boolean>(false)
  const sessionRoles = ref<Array<string>>(null)

  onBeforeMount( () => {
    verifySession()
  })

  async function verifySession() {
    try {
      sessionRoles.value = await sessionClient.roles()
    } catch {
      sessionRoles.value = null
    }
  }

  async function startSession() {
    if (!loginID.value || !loginSecret.value) {
      return
    }
    try {
      const token = await sessionClient.start(loginID.value, loginSecret.value)
      RutsolveToken.write(token, saveSession.value)
      router.go(0)
    } catch (e) {
      error.value = e
    }
  }

  function stopSession() {
    RutsolveToken.delete()
    router.go(0)
  }
</script>
